import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgContrastIconLt = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 56,
	height: 48,
	viewBox: "0 0 56 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M16.9699 24.0672C16.9699 31.3746 19.7801 37.862 24.4011 42.2332C23.6708 42.2994 22.9191 42.3314 22.144 42.3314C9.069 42.3314 0 34.755 0 24.3875C0 14.02 9.069 6.44141 22.144 6.44141C22.6629 6.44141 23.169 6.45208 23.658 6.4713C19.462 10.866 16.9699 17.1292 16.9699 24.0672Z",
			fill: "#004D45"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M55.6104 9.9169C56.2282 13.9016 53.1629 17.1816 47.9568 17.1816C40.1328 17.1816 38.7439 7.10455 23.6582 6.47033C27.4733 2.45787 32.7049 0 38.7567 0C38.876 0 38.9931 0 39.1124 0.00213488C47.8162 0.00213488 54.933 5.56704 55.6104 9.9169Z",
			fill: "#0E9E53"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M51.0857 31.7911C53.1032 32.184 55.6901 33.5635 55.6901 37.7575C55.6901 43.5808 46.6295 47.9264 39.0965 47.999C39.0965 47.999 39.0772 47.999 39.06 47.999C39.0471 47.999 39.0407 47.999 39.0342 47.999C39.0278 47.999 39.0256 47.999 39.0256 47.999C33.2889 47.9904 28.229 45.8272 24.4023 42.2312C37.6785 41.1058 43.8965 30.3839 51.0857 31.7911Z",
			fill: "#0A004F"
		})
	]
});
export default SvgContrastIconLt;
